// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","chip":"_3gVhWRQViaK3","chip_readonly":"_2bHihv8S2NXn","close":"_5TK2yBAUD-Te"};